webpackJsonp([1],{

/***/ "+9Yi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'plastic-primitive-page',
  beforeCreate: function beforeCreate() {
    document.body.className = 'plastic-primitive-page';
  }
});

/***/ }),

/***/ "+FwO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "column content page",
    attrs: {
      "id": "home-page"
    }
  }, [_c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('div', {
    staticClass: "top3 three"
  }), _vm._v(" "), _c('h1', {
    staticClass: "top"
  }, [_vm._v("Ready Made Go 3")]), _vm._v(" "), _c('div', {
    staticClass: "mid3 three"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "bot3 three"
  }), _vm._v(" "), _c('div', {
    staticClass: "right3 three"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "button audiotour",
    attrs: {
      "to": "/audio-tour"
    }
  }, [_vm._v("Start Audio Tour")])], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "mid"
  }, [_vm._v("20–24 September"), _c('br'), _vm._v("2017")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "bot"
  }, [_vm._v("Ace Hotel"), _c('br'), _vm._v("London")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+fFM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'more-page',
  beforeCreate: function beforeCreate() {
    document.body.className = 'more-page';
  }
});

/***/ }),

/***/ "0R+J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "progressContainer",
    staticClass: "progress-bar",
    on: {
      "click": _vm.seekToPosition
    }
  }, [_c('div', {
    staticClass: "time"
  }, [_c('span', {
    staticClass: "current"
  }, [_vm._v(_vm._s(_vm.completedTime))]), _vm._v(" "), _c('span', {
    staticClass: "final"
  }, [_vm._v(_vm._s(_vm.track.length))])]), _vm._v(" "), _c('div', {
    staticClass: "black-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "completed",
    style: ({
      width: _vm.completedWidth
    })
  }, [_c('div', {
    staticClass: "ball"
  })])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "13pN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "artist"
  }, [_c('div', {
    staticClass: "artist-heading"
  }, [_c('h2', [_c('span', {
    staticClass: "artist-name"
  }, [_vm._v(_vm._s(_vm.artist.name))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "artist-length"
  }, [_vm._v(_vm._s(_vm.artist.work))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "artist-location"
  }, [_vm._v(_vm._s(_vm.artist.about))]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.artist.href,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.artist.site))])])]), _vm._v(" "), _c('div', {
    staticClass: "artist-detail"
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": '/static/img/' + _vm.artist.image
    }
  })]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.artist.copy)
    }
  })])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4x7s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'exhibit-item',
  props: ['artist']
});

/***/ }),

/***/ "5Pli":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6Pgi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "column content page",
    attrs: {
      "id": "map-page"
    }
  }, [_c('div', {
    attrs: {
      "id": "map"
    }
  }, [_c('h1', [_vm._v("MAP")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/rmg-map.png",
      "alt": "Map of the selected artworks at Ace Hotel London"
    }
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9XCJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'map-page',
  beforeCreate: function beforeCreate() {
    document.body.className = 'map-page';
  }
});

/***/ }),

/***/ "AHHH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ListenPage_ProgressBar__ = __webpack_require__("WvlS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ListenPage_PlayerControls__ = __webpack_require__("wn+j");
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'soundcloud-player',
  props: ['track', 'soundcloud'],
  components: { ProgressBar: __WEBPACK_IMPORTED_MODULE_0__components_ListenPage_ProgressBar__["a" /* default */], PlayerControls: __WEBPACK_IMPORTED_MODULE_1__components_ListenPage_PlayerControls__["a" /* default */] }
});

/***/ }),

/***/ "BidL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "By/o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cwzi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  'artist': 'Welcome',
  'location': '',
  'length': '0:31',
  'length_seconds': '600',
  'tour_index': 1,
  'soundcloud_id': 342535190,
  'track_number': 0,
  'paragraph': '<p>The Ready Made Go project consists of a collection of new products that have been designed, developed and made (or found) especially for Ace Hotel London Shoreditch.</p><p><em>Modern Design Review</em> magazine curates the project. We intervene in the hotel’s usual procurement process and commission local designers and design groups to make objects that are then installed as part of the permanent interior of Ace Hotel London.</p><p>This is the third Ready Made Go collection and consists of five new objects; stools for Bulldog Café, salt &amp; pepper grinders for Hoi Polloi restaurant, café displays, mugs and coffee pots and tables for the lobby.</p><p>We seek to demonstrate the quality and diversity of design talent in London and take great pleasure in giving real commissions to independent designers and design studios, and in sharing the resulting solution-driven and exciting objects with the general public.</p>',
  'images': [{ 'src': '', 'caption': '' }, { 'src': '', 'caption': '' }, { 'src': '', 'caption': '' }, { 'src': '', 'caption': '' }, { 'src': '', 'caption': '' }, { 'src': '', 'caption': '' }, { 'src': '', 'caption': '' }, { 'src': '', 'caption': '' }, { 'src': '', 'caption': '' }]
}, {
  'artist': 'Soft Baroque',
  'title': 'Finger Tables',
  'location': 'Lobby',
  'tour_index': 2,
  'length': '4:42',
  'length_seconds': '600',
  'soundcloud_id': 342535189,
  // 340510726
  'track_number': 1,
  'paragraph': '<p>The Rhombus and Arc Finger Tables feature a distinctive finger joint more commonly found in carpentry. Transposing elements across mediums and questioning the familiar is typical of Soft Baroque’s (Nicholas Gardner and Saša Štucin’s) approach. Here they have worked with Alusid; an exciting new material made from 100% recycled ceramic and glass that is as strong as stone and as malleable as ceramic.</p>',
  'images': [{ 'src': 'SB_product_sq.jpg', 'caption': null }, { 'src': 'SB1_making.jpg', 'caption': null }, { 'src': 'SB2_making.jpg', 'caption': null }, { 'src': 'SB3_making.jpg', 'caption': null }, { 'src': 'SB4_making.jpg', 'caption': null }, { 'src': 'SB5_making.jpg', 'caption': null }, { 'src': 'SB6_making.jpg', 'caption': null }, { 'src': 'SB7_making.jpg', 'caption': null }, { 'src': 'SB8_making.jpg', 'caption': null }]
}, {
  'artist': 'Michael Marriott',
  'title': 'Totem Stool',
  'location': 'Bulldog Edition',
  'tour_index': 3,
  'length': '6:59',
  'length_seconds': '600',
  'soundcloud_id': 342535187,
  // 340510708
  'track_number': 2,
  'paragraph': '<p>The Totem stools are an exercise in economy and utility. Michael Marriott has made a stable and comfortable seat that maximises material and uses simple construction methods. These are clearly on display. The material used is Smile Plastics; an innovative sheet material made from 100% recycled waste plastic such as food containers, yoghurt pots and plastic bottles.</p>',
  'images': [{ 'src': 'MM_product_sq.jpg', 'caption': null }, { 'src': 'MM1_making.jpg', 'caption': null }, { 'src': 'MM2_making.jpg', 'caption': null }, { 'src': 'MM3_making.jpg', 'caption': null }, { 'src': 'MM4_making.jpg', 'caption': null }, { 'src': 'MM5_making.jpg', 'caption': null }, { 'src': 'MM6_making.jpg', 'caption': null }, { 'src': 'MM7_making.jpg', 'caption': null }, { 'src': 'MM8_making.jpg', 'caption': null }]
}, {
  'artist': 'Ian Mcintyre',
  'title': 'A1 Mug and Coffee Pot',
  'location': 'Bulldog Edition',
  'tour_index': 4,
  'length': '4:31',
  'soundcloud_id': 342535185,
  'track_number': 3,
  'paragraph': '<p>The A1 mug is intended as a do-all item for Ace, to be used throughout the hotel. Ian McIntyre has created an archetypal vessel that is tough, hardy and without pretension. The A1 Coffee Pot is similarly functional. Ease and efficiency of making has dictated the defining characteristics of the items; a moulded cylindrical body that is consistent and regular and a hand-shaped handle that is roughly finished and characterful.</p>',
  'images': [{ 'src': 'IM_product_sq.jpg', 'caption': null }, { 'src': 'IM1_making.jpg', 'caption': null }, { 'src': 'IM2_making.jpg', 'caption': null }, { 'src': 'IM3_making.jpg', 'caption': null }, { 'src': 'IM4_making.jpg', 'caption': null }, { 'src': 'IM5_making.jpg', 'caption': null }, { 'src': 'IM6_making.jpg', 'caption': null }, { 'src': 'IM7_making.jpg', 'caption': null }, { 'src': 'IM8_making.jpg', 'caption': null }]
}, {
  'artist': 'James Shaw',
  'title': 'Plastic Baroque Counter Displays',
  'location': 'Bulldog Edition',
  'tour_index': 5,
  'length': '3:55',
  'length_seconds': '600',
  'soundcloud_id': 342535181,
  'track_number': 4,
  'paragraph': '<p>Plastic Baroque is a method of making that James Shaw invented during his graduate year at the Royal College of Art. It involves a home-made, hand-held gun that melts and extrudes recycled plastic. The resulting material is expressive, structural and elaborate. James has applied the process to building counter display stands and tidies for Bulldog Café.</p>',
  'images': [{ 'src': 'JS_product_sq.jpg', 'caption': null }, { 'src': 'JS1_making.jpg', 'caption': null }, { 'src': 'JS2_making.jpg', 'caption': null }, { 'src': 'JS3_making.jpg', 'caption': null }, { 'src': 'JS4_making.jpg', 'caption': null }, { 'src': 'JS5_making.jpg', 'caption': null }, { 'src': 'JS6_making.jpg', 'caption': null }, { 'src': 'JS7_making.jpg', 'caption': null }, { 'src': 'JS8_making.jpg', 'caption': null }]
}, {
  'artist': 'Oscar Diaz',
  'title': 'Box Salt & Pepper Grinders',
  'location': 'Hoi Polloi',
  'tour_index': 6,
  'length': '2:16',
  'length_seconds': '600',
  'soundcloud_id': 342535143,
  'track_number': 5,
  'paragraph': '<p>Oscar Diaz has recycled a gesture in his Box salt and pepper grinders. The turning motion of the brass key is familiar and nostalgic, having been reappropriated from a childhood music box. Here the same motion is used to grind condiment. Oscar is concerned with elevating everyday objects and using industrial design to do so.</p>',
  'images': [{ 'src': 'OD_product_sq.jpg', 'caption': null }, { 'src': 'OD1_making.jpg', 'caption': null }, { 'src': 'OD2_making.jpg', 'caption': null }, { 'src': 'OD3_making.jpg', 'caption': null }, { 'src': 'OD4_making.jpg', 'caption': null }, { 'src': 'OD5_making.jpg', 'caption': null }, { 'src': 'OD6_making.jpg', 'caption': null }, { 'src': 'OD7_making.jpg', 'caption': null }, { 'src': 'OD8_making.jpg', 'caption': null }]
}]);

/***/ }),

/***/ "EEDE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "column content page",
    attrs: {
      "id": "exhibit-page"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("We purposefully selected graduates from a diverse range of design-related courses and institutions in the capital, hoping to demonstrate the breadth of design work currently being nurtured in London. We encourage you to further explore their work.")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "artists"
    }
  }, _vm._l((_vm.exhibit), function(artist) {
    return _c('exhibit-item', {
      key: artist.index,
      attrs: {
        "artist": artist
      }
    })
  }))])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("70 "), _c('sup', [_vm._v("×")]), _vm._v(" 40 "), _c('sup', [_vm._v("×")]), _vm._v(" 50")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("We invited eight recent graduates from London-based craft or industrial design courses to present a sample of their work in these diminutive display boxes; just 70 "), _c('sup', [_vm._v("×")]), _vm._v(" 40 "), _c('sup', [_vm._v("×")]), _vm._v(" 50 cm. Although small, the spaces provide a genuine platform for these, some of the city’s freshest new talents, to communicate a ‘taste’ of their ideas, solutions, motivations and preoccupations during London Design Festival.")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Feh4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GPNm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'player-controls',
  props: ['soundcloud'],
  methods: {
    backward: function backward() {
      this.soundcloud.api.prev();
      this.soundcloud.api.seekTo(0);
    },
    togglePlay: function togglePlay() {
      this.soundcloud.api.toggle();
    },
    forward: function forward() {
      this.soundcloud.api.next();
      this.soundcloud.api.seekTo(0);
    }
  }
});

/***/ }),

/***/ "GUTb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home-page',
  beforeCreate: function beforeCreate() {
    document.body.className = 'home-page';
  }
});

/***/ }),

/***/ "Gj4y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlasticPrimitivePage_vue__ = __webpack_require__("+9Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34e49c97_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PlasticPrimitivePage_vue__ = __webpack_require__("h9RD");
function injectStyle (ssrContext) {
  __webpack_require__("pWcQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34e49c97"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlasticPrimitivePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34e49c97_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PlasticPrimitivePage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IVwL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackListItem_vue__ = __webpack_require__("mU6b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a9ec604_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TrackListItem_vue__ = __webpack_require__("v2FW");
function injectStyle (ssrContext) {
  __webpack_require__("kBmZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a9ec604"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a9ec604_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TrackListItem_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KtSR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2205ba6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("drxv");
function injectStyle (ssrContext) {
  __webpack_require__("bkoe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2205ba6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mgto":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lazyload__ = __webpack_require__("cTzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_soundcloud_widget__ = __webpack_require__("ME+5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_soundcloud_widget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_soundcloud_widget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_underscore__ = __webpack_require__("rdLu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Tracklist_js__ = __webpack_require__("Cwzi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Exhibit_js__ = __webpack_require__("sz6d");

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_lazyload___default.a, {
  lazyComponent: true,
  listenEvents: ['scroll']
});

// Dummy Soundcloud API until
// the widget has actually loaded

var dummyAPI = {
  skip: function skip() {},
  toggle: function toggle() {},
  setVolume: function setVolume() {},
  seekTo: function seekTo() {},
  pause: function pause() {},
  play: function play() {},
  prev: function prev() {},
  next: function next() {},
  isPaused: function isPaused() {},
  getDuration: function getDuration() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {});
  }
};

var soundcloud = {
  api: dummyAPI,
  ready: false,
  playing: false,
  progress: 0
};

var app = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({ // eslint-disable-line no-new
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  data: {
    soundcloud: soundcloud,
    tracklist: __WEBPACK_IMPORTED_MODULE_7__Tracklist_js__["a" /* default */],
    exhibit: __WEBPACK_IMPORTED_MODULE_8__Exhibit_js__["a" /* default */]
  },
  template: '<App v-bind:soundcloud="soundcloud" v-bind:tracklist="tracklist" v-bind:exhibit="exhibit"/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

function initializeSoundcloud() {
  var soundcloudSnippet = document.createElement('iframe');
  soundcloudSnippet.id = 'soundcloud';
  soundcloudSnippet.width = '100%';
  soundcloudSnippet.height = '300';
  soundcloudSnippet.scrolling = 'no';
  soundcloudSnippet.frameborder = 'no';
  soundcloudSnippet.src = 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/352947262%3Fsecret_token%3Ds-viIN5&amp;color=ffffff&amp;auto_play=false&amp;hide_related=true&amp;show_comments=false&amp;show_user=false&amp;show_reposts=false&amp;visual=false';
  document.body.appendChild(soundcloudSnippet);

  var soundcloudAPI = new __WEBPACK_IMPORTED_MODULE_5_soundcloud_widget___default.a(document.querySelector('iframe'));

  soundcloudAPI.bind(__WEBPACK_IMPORTED_MODULE_5_soundcloud_widget___default.a.events.PLAY_PROGRESS, function (progress) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(soundcloud, 'progress', progress);
  });

  soundcloudAPI.bind(__WEBPACK_IMPORTED_MODULE_5_soundcloud_widget___default.a.events.PLAY, function () {
    app.soundcloud.playing = true;
    soundcloudAPI.getCurrentSound().then(function (sound) {
      __WEBPACK_IMPORTED_MODULE_6_underscore___default.a.each(app.tracklist, function (track) {
        if (track.soundcloud_id === sound.id) {
          track.playing = true;
        } else {
          track.playing = false;
        }
      });
    });
  });

  soundcloudAPI.bind(__WEBPACK_IMPORTED_MODULE_5_soundcloud_widget___default.a.events.PAUSE, function (progress) {
    app.soundcloud.playing = false;
    if (progress.relativePosition > 0.999) {
      // If we are pausing because it is the end
      // of the track, seek to zero.
      // console.log('End of track. Do not seek.')
      soundcloudAPI.setVolume(0);
      soundcloudAPI.seekTo(0);
      var currentTrack = __WEBPACK_IMPORTED_MODULE_6_underscore___default.a.findWhere(app.tracklist, { playing: true });
      soundcloudAPI.skip(currentTrack.track_number);
      soundcloudAPI.pause();
      soundcloudAPI.setVolume(100);
    } else {
      // If we are pausing for any other reason,
      // signal that we are
      __WEBPACK_IMPORTED_MODULE_6_underscore___default.a.each(app.tracklist, function (track) {
        track.playing = false;
      });
    }
  });

  soundcloudAPI.bind(__WEBPACK_IMPORTED_MODULE_5_soundcloud_widget___default.a.events.READY, function () {
    app.soundcloud.ready = true;
  });

  app.soundcloud.api = soundcloudAPI;
}

initializeSoundcloud();

/***/ }),

/***/ "VOiu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ExhibitPage_ExhibitItem__ = __webpack_require__("qpYY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'exhibit-page',
  props: ['exhibit'],
  components: { ExhibitItem: __WEBPACK_IMPORTED_MODULE_0__components_ExhibitPage_ExhibitItem__["a" /* default */] },
  beforeCreate: function beforeCreate() {
    document.body.className = 'exhibit-page';
  }
});

/***/ }),

/***/ "VubG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WvlS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressBar_vue__ = __webpack_require__("zL+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1472486e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressBar_vue__ = __webpack_require__("0R+J");
function injectStyle (ssrContext) {
  __webpack_require__("hlRL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1472486e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1472486e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressBar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XH2m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XOQi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackListDetail_vue__ = __webpack_require__("psKH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5008fbfc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TrackListDetail_vue__ = __webpack_require__("lMa/");
function injectStyle (ssrContext) {
  __webpack_require__("KtSR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5008fbfc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackListDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5008fbfc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TrackListDetail_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Xw3i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExhibitPage_vue__ = __webpack_require__("VOiu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74c55ca0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ExhibitPage_vue__ = __webpack_require__("EEDE");
function injectStyle (ssrContext) {
  __webpack_require__("BidL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74c55ca0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExhibitPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74c55ca0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ExhibitPage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HomePage__ = __webpack_require__("wrM5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ListenPage_ListenPage__ = __webpack_require__("lf71");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MapPage__ = __webpack_require__("xHhH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ExhibitPage_ExhibitPage__ = __webpack_require__("Xw3i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PlasticPrimitivePage__ = __webpack_require__("Gj4y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_MorePage__ = __webpack_require__("esSS");









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'HomePage',
    component: __WEBPACK_IMPORTED_MODULE_2__components_HomePage__["a" /* default */]
  }, {
    path: '/audio-tour',
    name: 'ListenPage',
    component: __WEBPACK_IMPORTED_MODULE_3__components_ListenPage_ListenPage__["a" /* default */]
  }, {
    path: '/map',
    name: 'MapPage',
    component: __WEBPACK_IMPORTED_MODULE_4__components_MapPage__["a" /* default */]
  }, {
    path: '/70x40x50',
    name: 'ExhibitPage',
    component: __WEBPACK_IMPORTED_MODULE_5__components_ExhibitPage_ExhibitPage__["a" /* default */]
  }, {
    path: '/plastic-primitive',
    name: 'PlasticPrimitivePage',
    component: __WEBPACK_IMPORTED_MODULE_6__components_PlasticPrimitivePage__["a" /* default */]
  }, {
    path: '/more',
    name: 'MorePage',
    component: __WEBPACK_IMPORTED_MODULE_7__components_MorePage__["a" /* default */]
  }],
  mode: 'history'
}));

/***/ }),

/***/ "bkoe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "drxv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nav', {
    staticClass: "navbar rmg-header",
    attrs: {
      "role": "navigation",
      "aria-label": "main navigation"
    }
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Ready Made Go 3")]), _vm._v(" "), _c('div', {
    staticClass: "navbar-burger burger",
    class: {
      'is-active': _vm.showNav
    },
    attrs: {
      "data-target": "rmg-menu"
    },
    on: {
      "click": function($event) {
        _vm.showNav = !_vm.showNav
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu",
    class: {
      'is-active': _vm.showNav
    },
    attrs: {
      "id": "rmg-menu"
    }
  }, [_c('div', {
    staticClass: "navbar-start"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/audio-tour"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideNav($event)
      }
    }
  }, [_vm._v("Audio Tour")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/map"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideNav($event)
      }
    }
  }, [_vm._v("Map")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/70x40x50"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideNav($event)
      }
    }
  }, [_vm._v("70 "), _c('sup', [_vm._v("×")]), _vm._v(" 40 "), _c('sup', [_vm._v("×")]), _vm._v(" 50")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/plastic-primitive"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideNav($event)
      }
    }
  }, [_vm._v("Plastic Primitive")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/more"
    },
    nativeOn: {
      "click": function($event) {
        _vm.hideNav($event)
      }
    }
  }, [_vm._v("More")])], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('section', {
    staticClass: "page columns"
  }, [_c('router-view', {
    attrs: {
      "soundcloud": _vm.soundcloud,
      "tracklist": _vm.tracklist,
      "exhibit": _vm.exhibit
    }
  })], 1), _vm._v(" "), _vm._m(1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-end"
  }, [_c('p', [_vm._v("Presented by")]), _vm._v(" "), _c('img', {
    staticClass: "mdr-logo",
    attrs: {
      "src": "/static/img/rmg-mdr_logo.png",
      "alt": "Modern Design Review"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rmg-footer"
  }, [_c('p', [_vm._v("Ace Hotel London   20-24 September 2017")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ekoj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ListenPage_SoundcloudPlayer__ = __webpack_require__("ovnz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ListenPage_TrackListItem__ = __webpack_require__("IVwL");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'listen-page',
  props: ['soundcloud', 'tracklist'],
  components: { SoundcloudPlayer: __WEBPACK_IMPORTED_MODULE_0__components_ListenPage_SoundcloudPlayer__["a" /* default */], TrackListItem: __WEBPACK_IMPORTED_MODULE_1__components_ListenPage_TrackListItem__["a" /* default */] },
  beforeCreate: function beforeCreate() {
    document.body.className = 'listen-page';
  }
});

/***/ }),

/***/ "esSS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MorePage_vue__ = __webpack_require__("+fFM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_634add45_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_MorePage_vue__ = __webpack_require__("iM9H");
function injectStyle (ssrContext) {
  __webpack_require__("VubG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-634add45"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MorePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_634add45_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_MorePage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f+5w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.track.expanded) ? _c('div', {
    staticClass: "column col-fixed",
    attrs: {
      "id": "player"
    }
  }, [_c('progress-bar', {
    attrs: {
      "soundcloud": _vm.soundcloud,
      "track": _vm.track
    }
  }), _vm._v(" "), _c('player-controls', {
    attrs: {
      "soundcloud": _vm.soundcloud
    }
  })], 1) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fnG/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h9RD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "column content page",
    attrs: {
      "id": "plastic-primitive-page"
    }
  }, [_c('h1', [_vm._v("PLASTIC PRIMITIVE"), _c('br'), _vm._v("BY JAMES SHAW")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', [_vm._v("During London Design Festival, designer James Shaw will take over the main  entrance to Ace Hotel London with the installation Plastic Primitive. Using his invented process of Plastic Baroque (see also James’ Ready Made Go 3 Plastic Baroque Counter Displays) James will reimagine the leafy entrance area creating plant stands and a towering plant totem.")]), _vm._v(" "), _c('p', [_vm._v("James notes that organic matter, including plants, of past millennia are the source material for oil and plastic; ‘At Ace Hotel London we will play with the seeming perversity of surrounding living plants with plastic to create a playful and irreverent origin story of this very commonplace material.’")]), _vm._v(" "), _c('p', [_vm._v("Sound Artist Marina Stanimirovic has produced an original soundtrack for Plastic Primitive that merges live baroque music, field recordings and sounds from the extrusion process itself.")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hlRL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iM9H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "column content page",
    attrs: {
      "id": "more-page"
    }
  }, [_c('h1', [_vm._v("MORE")]), _vm._v(" "), _c('div', {
    staticClass: "block",
    attrs: {
      "id": "past-products"
    }
  }, [_c('h2', [_vm._v("READY MADE GO PAST")]), _vm._v(" "), _c('p', [_vm._v("Ready Made Go is an ongoing project. So far, eighteen designs have been made by seventeen different London-based designers and design groups since 2015. All of those objects can be seen in use today in the hotel interior. The objects range from small items, like a door handle, to large installations, like the gymnasium climbing wall. Here are previously launched items to look out for:")]), _vm._v(" "), _c('p', [_vm._v("Spin copper ashtray "), _c('br'), _vm._v("\n      by Tomás Alonso")]), _vm._v(" "), _c('p', [_vm._v("BBQ ceramic tiles "), _c('br'), _vm._v("\n      by Assemble")]), _vm._v(" "), _c('p', [_vm._v("Mono sunglasses "), _c('br'), _vm._v("\n      by Parsha Gerayesh")]), _vm._v(" "), _c('p', [_vm._v("The Erosianal Remnant sculpture "), _c('br'), _vm._v("\n      by Hilda Hellström")]), _vm._v(" "), _c('p', [_vm._v("Amorph drinking glasses "), _c('br'), _vm._v("\n      by Jochen Holz")]), _vm._v(" "), _c('p', [_vm._v("Ace stacking stool "), _c('br'), _vm._v("\n      by Philippe Malouin")]), _vm._v(" "), _c('p', [_vm._v("Hex door handle "), _c('br'), _vm._v("\n      by Philippe Malouin")]), _vm._v(" "), _c('p', [_vm._v("Ascension bouldering wall "), _c('br'), _vm._v("\n      by Patternity")]), _vm._v(" "), _c('p', [_vm._v("Here & There signage "), _c('br'), _vm._v("\n      by Kellenberger White")]), _vm._v(" "), _c('p', [_vm._v("Botanic Jewellery "), _c('br'), _vm._v("\n      by Marcin Rusak")]), _vm._v(" "), _c('p', [_vm._v("Beam soap dishes "), _c('br'), _vm._v("\n      by Silo Studio")]), _vm._v(" "), _c('p', [_vm._v("The Doublet quilt "), _c('br'), _vm._v("\n      by Toogood")]), _vm._v(" "), _c('p', [_vm._v("Cast lights "), _c('br'), _vm._v("\n      by Studio Vit")])]), _vm._v(" "), _c('div', {
    staticClass: "block",
    attrs: {
      "id": "contacts"
    }
  }, [_c('h2', [_vm._v("CONTACTS")]), _vm._v(" "), _c('p', [_vm._v("Ready Made Go 3"), _c('br'), _vm._v("\n      20–24 September 2017"), _c('br'), _vm._v("\n      Ace Hotel London"), _c('br'), _vm._v("\n      100 Shoreditch High Street")]), _vm._v(" "), _c('p', [_vm._v("For further information or imagery, please contact:"), _c('br'), _vm._v("\n      Camron PR"), _c('br'), _vm._v("\n      +44 (0)20 7240 1700"), _c('br'), _vm._v("\n      Sarah Ferrall"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:sarah.ferrall@camronpr.com"
    }
  }, [_vm._v("sarah.ferrall@camronpr.com")]), _c('br'), _vm._v("\n      Kerry Lynch"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:kerry.lynch@camronpr.com"
    }
  }, [_vm._v("kerry.lynch@camronpr.com")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "https://www.dropbox.com/sh/ba9p70zi926i520/AACFudgTECEEtyKVthd5A49Ha?dl=0",
      "target": "_blank"
    }
  }, [_vm._v("IMAGE & MEDIA KIT")])]), _vm._v(" "), _c('div', {
    staticClass: "block",
    attrs: {
      "id": "modern-design-review"
    }
  }, [_c('h2', [_vm._v("MODERN DESIGN REVIEW")]), _vm._v(" "), _c('p', [_vm._v("Modern Design Review is an international, independent, magazine that covers the best of the product, people and theory at the effervescent tip of contemporary design. The London-based publication offers a considered and curated insight into modern design through original and creative storytelling and contributions from talented photographers, writers and designers.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "http://www.moderndesignreview.com",
      "target": "_blank"
    }
  }, [_vm._v("moderndesignreview.com")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://instagram.com/modern_design_review",
      "target": "_blank"
    }
  }, [_vm._v("@modern_design_review")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/mdreview14",
      "target": "_blank"
    }
  }, [_vm._v("@MDREVIEW14")])])]), _vm._v(" "), _c('div', {
    staticClass: "block",
    attrs: {
      "id": "ace-hotel-london"
    }
  }, [_c('h2', [_vm._v("ACE HOTEL LONDON")]), _vm._v(" "), _c('p', [_vm._v("Ace Hotel London hangs its hat in London's most creative and engaged district – a focus for culture, home of the world famous open-air market on Brick Lane and a canvas for street artists the world over. The neighbourhood's legacy includes theatres running banned 16th century plays, the debut of drag pioneer Hetty King and the first rumbles of industrialized craft in the Western Hemisphere. Today's Shoreditch is a leader in art, design, cuisine, culture and technology – an outpost in the global community of ideas.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "http://www.acehotel.com/london",
      "target": "_blank"
    }
  }, [_vm._v("acehotel.com/london")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://instagram.com/acehotel",
      "target": "_blank"
    }
  }, [_vm._v("@acehotel")])])]), _vm._v(" "), _c('div', {
    staticClass: "block",
    attrs: {
      "id": "credits"
    }
  }, [_c('h2', [_vm._v("CREDITS")]), _vm._v(" "), _c('p', [_vm._v("Identity, exhibition design and website design by Daly & Lyon"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.daly-lyon.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("daly-lyon.co.uk")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://instagram.com/daly_lyon",
      "target": "_blank"
    }
  }, [_vm._v("@daly_lyon")])]), _vm._v(" "), _c('p', [_vm._v("Website development by "), _c('a', {
    attrs: {
      "href": "http://atelierace.com",
      "target": "_blank"
    }
  }, [_vm._v("Atelier Ace")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("Making photography by:"), _c('br'), _vm._v("\n      Peter Guenzel (Michael Marriott Totem Stool)"), _c('br'), _vm._v("\n      Jorn Tomter (All other making photography)"), _c('br'), _vm._v("\n      Nicholas Gardner and Alasdair Bremner (Additional Finger Table photography)")]), _vm._v(" "), _c('p', [_vm._v("Still life photography by:"), _c('br'), _vm._v("\n      Ansgar Sollmann")]), _vm._v(" "), _c('p', [_vm._v("Finger Tables kindly sponsored by Alusid"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.alusid.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("alusid.co.uk")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://instagram.com/alusiduk",
      "target": "_blank"
    }
  }, [_vm._v("@alusiduk")])]), _vm._v(" "), _c('p', [_vm._v("Special thanks to "), _c('a', {
    attrs: {
      "href": "http://www.smileplastics.com",
      "target": "_blank"
    }
  }, [_vm._v("Smile Plastics")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "http://www.veolia.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("Veolia")]), _vm._v(".")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kBmZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lMa/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.track.expanded) ? _c('div', {
    staticClass: "track-detail content"
  }, [_c('figure', {
    staticClass: "firstImage"
  }, [_c('img', {
    staticStyle: {
      "min-height": "300px"
    },
    attrs: {
      "src": '/static/img/' + _vm.firstImage.src
    }
  }), _vm._v(" "), _c('figcaption', {
    staticClass: "is-size-7"
  }, [_vm._v(_vm._s(_vm.firstImage.caption))])]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.track.paragraph)
    }
  }), _vm._v(" "), _vm._l((_vm.moreImages), function(image) {
    return _c('figure', [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: ('/static/img/' + image.src),
        expression: "'/static/img/'+image.src"
      }],
      staticStyle: {
        "min-height": "200px"
      }
    }), _vm._v(" "), _c('figcaption', {
      staticClass: "is-size-7"
    }, [_vm._v(_vm._s(image.caption))])])
  })], 2) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lf71":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListenPage_vue__ = __webpack_require__("ekoj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f859ef44_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ListenPage_vue__ = __webpack_require__("qUTd");
function injectStyle (ssrContext) {
  __webpack_require__("5Pli")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f859ef44"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListenPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f859ef44_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ListenPage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mU6b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ListenPage_TrackListDetail__ = __webpack_require__("XOQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_velocity_animate__ = __webpack_require__("9qgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_velocity_animate__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'track-list-item',
  props: ['track', 'soundcloud'],
  components: { TrackListDetail: __WEBPACK_IMPORTED_MODULE_1__components_ListenPage_TrackListDetail__["a" /* default */] },
  methods: {
    toggle: function toggle() {
      if (!this.track.expanded && !this.track.playing) {
        // @TODO Velocity isn't work
        __WEBPACK_IMPORTED_MODULE_2_velocity_animate___default()(this.$el, 'scroll', {
          container: document.getElementById('track-list'),
          duration: 1000,
          offset: 102
        });
        this.soundcloud.api.setVolume(0);
        this.soundcloud.api.skip(this.track.track_number);
        // I'm lowering and then raising volume
        // to avoid a blip of sound that sometimes
        // occurs when re-pausing a track that is
        // already paused
        this.soundcloud.api.setVolume(100);
        this.soundcloud.api.seekTo(0);
      } else {
        this.soundcloud.api.pause();
      }

      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(this.track, 'expanded', !this.track.expanded);
    }
  }
});

/***/ }),

/***/ "ovnz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SoundcloudPlayer_vue__ = __webpack_require__("AHHH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a0b7822_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SoundcloudPlayer_vue__ = __webpack_require__("f+5w");
function injectStyle (ssrContext) {
  __webpack_require__("fnG/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8a0b7822"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SoundcloudPlayer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a0b7822_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SoundcloudPlayer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pWcQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "psKH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'track-list-detail',
  props: ['track'],
  computed: {
    firstImage: function firstImage() {
      if (this.track.images.length > 0) {
        return this.track.images[0];
      } else {
        return {
          src: '',
          caption: ''
        };
      }
    },
    moreImages: function moreImages() {
      if (this.track.images.length > 0) {
        return this.track.images.slice(1);
      } else {
        return [];
      }
    }
  },
  methods: {
    toggle: function toggle() {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(this.track, 'expanded', false);
    }
  }
});

/***/ }),

/***/ "q98E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "controls"
  }, [_c('button', {
    on: {
      "click": _vm.togglePlay
    }
  }, [_c('i', {
    staticClass: "fa play-pause",
    class: {
      'fa-circle-o-notch': !_vm.soundcloud.ready, 'fa-play': !_vm.soundcloud.playing, 'fa-pause': _vm.soundcloud.playing
    }
  })])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qUTd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "column",
    attrs: {
      "id": "listen-page"
    }
  }, [_c('div', {
    attrs: {
      "id": "track-list"
    }
  }, _vm._l((_vm.tracklist), function(track) {
    return _c('track-list-item', {
      key: track.track_number,
      attrs: {
        "track": track,
        "soundcloud": _vm.soundcloud
      }
    })
  })), _vm._v(" "), _vm._l((_vm.tracklist), function(track) {
    return _c('soundcloud-player', {
      key: track.track_number,
      attrs: {
        "track": track,
        "soundcloud": _vm.soundcloud
      }
    })
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qpYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExhibitItem_vue__ = __webpack_require__("4x7s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4edaef98_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ExhibitItem_vue__ = __webpack_require__("13pN");
function injectStyle (ssrContext) {
  __webpack_require__("By/o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4edaef98"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExhibitItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4edaef98_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ExhibitItem_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sz6d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  'name': 'Sylvain De Bellis',
  'work': 'Linear',
  'about': 'MA Design Products, Royal College of Art',
  'site': 'www.sylvaindebellis.com',
  'href': 'http://www.www.sylvaindebellis.com',
  'image': 'Sylvain-De-Bellis.jpg',
  'copy': '<p>Linear is a 100% recyclable and disposable toothbrush. The product is made from recycled and extruded Tynex® 612 Nylon, the most efficient material for oral care. Ultrasonic welding technology forms the material into both bristle and handle.</p><p>Sylvain De Bellis’ project aims to reduce the complexity of the manufacturing process in the production of regular manual/disposable toothbrushes. These are currently produced using a minimum of three materials, the process of arranging the bristles is complex, using metal staples, making such them non-recyclable in their current form unless broken down.</p><p>The Linear toothbrush utilises Ultrasonic Welding Technology (developed with the help of Telsonic Ltd) to fuse filaments together in one operation. The ultrasounds spot-fuse the filaments to form both a dense handle and an arranged bristle formation.</p>'
}, {
  'name': 'Callum Partridge',
  'work': 'The Shift',
  'about': 'BA Metalwork Design, The CASS London Metropolitan University',
  'site': 'callum.partridge95@gmail.com',
  'href': 'mailto:callum.partridge95@gmail.com',
  'image': 'Callum-Partridge.jpg',
  'copy': '<p>This collection of mixed metal objects articulates ‘movement’ and explores form. The objects demonstrate the different techniques that Callum has explored during his final year of study, challenging himself to attain a professional standard of making. Callum used a mix of metals including brass, gilding metal and silver to achieve a variety of finishes. His ambition was to allow each metal to speak its own truth and communicate honesty.</p><p>Although a collection, each piece moves at a different speed due to its weight and shape. These objects have their own individual character, a trait particularly visible in movement.</p>'
}, {
  'name': 'Laura Stevens',
  'work': 'Manifest',
  'about': 'BA Textile Design, Central Saint Martins',
  'site': 'laurastevens_@outlook.com',
  'href': 'mailto:callum.partridge95@gmail.com',
  'image': 'Laura-Stevens.jpg',
  'copy': '<p>The aim of Manifest, Laura Stevens final year project, was to explore the issue of waste in and around London. Laura has sought to create something visually compelling using waste as a starting point, an idea which is typically undesirable and aesthetically unpleasing.</p><p>Laura’s research uncovered interesting and unpredictable pattern, colour, texture and shape thrown together at random. She collected physical waste as part of the research process, created collages using the found materials, developing shape, colour, texture and composition. The collection combines dyed laser-cut shapes with simple screen-printed fabrics. The application of foam shapes adds a three-dimensional quality to the otherwise flat prints.</p>'
}, {
  'name': 'Mo Tizro',
  'work': 'MoJo',
  'about': 'BA Design Products, Ravensbourne College',
  'site': 'www.tizrodesigns.com',
  'href': 'http://www.tizrodesigns.com',
  'image': 'Mo-Tizro.jpg',
  'copy': '<p>MoJo is a system of spring steel joints that can be used in conjunction with off-the-shelf wooden dowels to create furniture for homes and workspaces. MoJo presents an alternative to ubiquitous flat packed furniture and provides a creative and flexible solution with a broad range of uses.</p><p>MoJo’s steel shell keeps wooden rods in place without the need for additional fixings or screws. Rubber feet and other elements can be added. Mojo joints and wooden dowels make a robust framing system for shelving units, tables, stools, benches, desks, wardrobes. Mojo allows the end user to make what they need. The joints can be reused over and over again, allowing the customer to evolve and adapt their furniture without creating excess waste.</p>'
}, {
  'name': 'Inge Sluijs',
  'work': 'Plasma Rock',
  'about': 'MA Material Futures, Central Saint Martins',
  'site': 'www.ingesluijs.nl',
  'href': 'http://www.ingesluijs.nl',
  'image': 'Inge-Sluijs.jpg',
  'copy': '<p>Inge Sluijs has explored the new technology of plasma gasification; a process where landfill material is extracted and heated to such a temperature that it renders all known substances to rock and gas. The waste gas produced is perceived as a potentially valuable alternative to fossil fuels and natural gas whilst the plasma rock has, until now, been attributed no real viable commercial value or application.</p><p>The qualities of Plasma Rock are strength, density and environmental stability. 100 kg of landfill waste will result in 20 kg of the Plasma Rock.</p><p>Inge identified key sites, such as Tilbury, and has set out to develop a new localised craft process that in itself could become a viable alternative to environmentally unfriendly processes/materials. She has created a powder from plasma rock which can be formed and applied to different objects. Her ‘Tilbury Tiles’ are an imagined souvenir from that might one day exist as part of a circular economy in the area, turning landfill into consumer goods. Similarly, her glass vessels demonstrate an attractive use of the plasma rock and how this unusual material has uncommon potential applications.</p>'
}, {
  'name': 'William Drye',
  'work': 'Pinch',
  'about': 'BA Design Products, Kingston University',
  'site': 'www.williamdrye.com',
  'href': 'http://www.williamdrye.com',
  'image': 'William-Drye.jpg',
  'copy': '<p>Pinch is an exploration into the process of metal tube pinching. William Drye was attracted to the process because of its simplicity and functionality and the beautiful forms it creates. The process is one commonly used but not usually celebrated as the main feature of a product.</p><p>The process allowed William to change the shape of a standard component; a metal tube, with a single dynamic action. Pinch tests an off-the-shelf material, turning something common into something unique. The project resulted in a small family of objects that share the same manufacturing process and material; a lamp, coat hooks and candlesticks. The lamp is clamped together by two uprights of Douglas Fir, holding the shade, cord and base in place. The candlesticks supporting channel is a surface for salt, pepper, matches or condiments. All metal components are powder coated.</p>'
}, {
  'name': 'Nicholas Marschner',
  'work': 'Formed Fleece',
  'about': 'BA Furniture and Product Design, The CASS London Metropolitan University',
  'site': 'www.nicholasmarschner.com',
  'href': 'http://www.nicholasmarschner.com',
  'image': 'Nicholas-Marschner.jpg',
  'copy': '<p>A project brief concerned with sound isolation and contract furniture led Nicholas Marschner to begin a period of investigation of ideas around scale and monolithic structures within the urban landscape. Corrugated metal, a detail most commonly seen on the facades of storage warehouses, became the starting point for a design.</p><p>Formed Fleece is a fabric paneling system, made using a heat-formed corrugated fleece, inset (numidium) magnets and timber uprights. The system is intended for flexible, knock-down, work spaces.</p><p>The Formed Fleece booths are a simple click together structure. They are versatile, modular, moveable and sound-insulated workspaces, a response to an increasingly transient workplace.</p>'
}, {
  'name': 'Victoria Andrew',
  'work': 'Balance + Form ',
  'about': 'MA Ceramics and Glass, Royal College of Art',
  'site': 'victoria-andrew.net',
  'href': 'http://www.victoria-andrew.net',
  'image': 'Victoria-Andrew.jpg',
  'copy': '<p>Balance + Form are a series of works exploring materiality and surface in glass and ceramic forms. By incorporating elements of balance and vulnerability, material compositions become sculptural forms which explore the built environment on a playful scale.</p><p>Victoria works by creating a set of individual components, and then taking time to combine them and compose them. The elements are interchangeable and because of this photography plays a large role in documenting the different iterations. Geometric forms are references to architectural structures and the materials used are those commonly found in construction. Each individual form highlights elements unique to the material that may be overlooked in day-to-day use.</p>'
}]);

/***/ }),

/***/ "v2FW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "track",
    class: {
      expanded: _vm.track.expanded
    },
    attrs: {
      "id": 'track' + _vm.track.tour_index
    }
  }, [_c('div', {
    staticClass: "track-heading"
  }, [_c('h2', {
    staticClass: "artist",
    on: {
      "click": _vm.toggle
    }
  }, [_c('span', {
    staticClass: "track-number"
  }, [_vm._v(_vm._s(_vm.track.tour_index))]), _vm._v(" "), _c('span', {
    staticClass: "track-name"
  }, [_vm._v(_vm._s(_vm.track.artist))])]), _vm._v(" "), _c('h3', {
    staticClass: "art"
  }, [_vm._v(_vm._s(_vm.track.title))]), _vm._v(" "), _c('h3', {
    staticClass: "info"
  }, [_c('span', {
    staticClass: "track-length"
  }, [_vm._v(_vm._s(_vm.track.length))]), _vm._v(" "), _c('span', {
    staticClass: "track-location"
  }, [_vm._v(_vm._s(_vm.track.location))])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('track-list-detail', {
    attrs: {
      "track": _vm.track
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wn+j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlayerControls_vue__ = __webpack_require__("GPNm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9dcbf8c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PlayerControls_vue__ = __webpack_require__("q98E");
function injectStyle (ssrContext) {
  __webpack_require__("XH2m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9dcbf8c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlayerControls_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9dcbf8c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PlayerControls_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wrM5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomePage_vue__ = __webpack_require__("GUTb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77636ccf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_HomePage_vue__ = __webpack_require__("+FwO");
function injectStyle (ssrContext) {
  __webpack_require__("Mgto")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77636ccf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77636ccf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_HomePage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xHhH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapPage_vue__ = __webpack_require__("9XCJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e279a64c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_MapPage_vue__ = __webpack_require__("6Pgi");
function injectStyle (ssrContext) {
  __webpack_require__("Feh4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e279a64c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e279a64c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_MapPage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  props: ['soundcloud', 'tracklist', 'exhibit'],
  data: function data() {
    return { showNav: false };
  },

  watch: {
    '$route': function $route() {
      // this.showNav = false
      this.soundcloud.api.pause();
    }
  },
  methods: {
    hideNav: function hideNav() {
      this.showNav = false;
    }
  }
});

/***/ }),

/***/ "zL+m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'progress-bar',
  props: ['soundcloud', 'track'],
  data: function data() {
    return {
      time: 0
    };
  },
  computed: {
    completedWidth: function completedWidth() {
      var newWidth = Math.floor(100000 * this.soundcloud.progress.relativePosition) / 1000;
      return newWidth + '%';
    },
    completedTime: function completedTime() {
      if (!this.soundcloud.progress.currentPosition) {
        return '0:00';
      }
      var positionInSeconds = this.soundcloud.progress.currentPosition / 1000;
      var minutes = Math.floor(positionInSeconds / 60);
      var seconds = Math.floor(positionInSeconds - 60 * minutes);
      var timeString = minutes.toString() + ':';
      if (seconds < 10) {
        timeString += '0' + seconds.toString();
      } else {
        timeString += seconds.toString();
      }
      return timeString;
    }
  },
  methods: {
    seekToPosition: function seekToPosition(event) {
      var progressContainer = this.$refs.progressContainer;
      var width = progressContainer.offsetWidth;
      var rect = progressContainer.getBoundingClientRect();
      var position = event.clientX - rect.left + document.body.scrollLeft;
      var percent = position / width;
      var api = this.soundcloud.api;
      this.soundcloud.api.getDuration().then(function (duration) {
        var newPosition = Math.floor(duration * percent);
        api.seekTo(newPosition);
      });
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.c9ce36bbc66cf2ec1344.js